import React, { useRef, useState } from 'react'
import { Auth } from 'aws-amplify'
import { cleanAdviser } from '../Store/adviser/actions'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { storage } from '../Utils/storage'
import SimpleModal from './simpleModal'
import CloudMessage from './cloudMessage'
import sadguy from '../Resources/svg/sad-guy.svg'
import { logout } from '../Store/loginRedux/actions'
import {
    cleanConfigProduct,
    cleanTablePdf,
    cleanTablePdfRI,
} from '../Store/secureInvestmentIncome/actions'

const ModalRegisterAdviser = ({ open }) => {
    const dispatch = useDispatch()
    const history = useHistory()

    const signOut = () => {
        window.open(process.env.REACT_APP_OAUTH2_LOGOUT)
        Auth.signOut({ global: true })
            .then((res) => console.log(res))
            .catch((e) => console.log(e))
    }

    const closeSession = async () => {
        await dispatch(logout())
        await dispatch(cleanTablePdf())
        await dispatch(cleanTablePdfRI())
        await dispatch(cleanConfigProduct())
        await dispatch(cleanAdviser())
        storage().removeItem('jwt')
        history.push('/login')

        setTimeout(() => {
            signOut()
        }, 500)
    }

    return (
        <SimpleModal isOpen={open}>
            <CloudMessage
                altImage="Imagen de un hombre triste"
                mainMessage="No se encontró su correo corporativo en SAS"
                secondaryMessage="Si el error persiste, por favor contáctese
con Mesa de ayuda"
                onClick={() => closeSession()}
                buttonText="Aceptar"
            />
        </SimpleModal>
    )
}

export default ModalRegisterAdviser
